import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["initialFocus", "containers", "features"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import m, { useEffect as k, useRef as i } from "react";
import { forwardRefWithAs as A, render as h } from "../../utils/render.js";
import { useServerHandoffComplete as S } from "../../hooks/use-server-handoff-complete.js";
import { useSyncRefs as g } from "../../hooks/use-sync-refs.js";
import { Features as M, Hidden as L } from "../../internal/hidden.js";
import { focusElement as c, focusIn as b, Focus as p, FocusResult as y } from "../../utils/focus-management.js";
import { match as B } from "../../utils/match.js";
import { useEvent as I } from "../../hooks/use-event.js";
import { useTabDirection as P, Direction as d } from "../../hooks/use-tab-direction.js";
import { useIsMounted as _ } from "../../hooks/use-is-mounted.js";
import { useOwnerDocument as U } from "../../hooks/use-owner.js";
import { useEventListener as H } from "../../hooks/use-event-listener.js";
import { microTask as C } from "../../utils/micro-task.js";
import { useWatch as R } from "../../hooks/use-watch.js";
var N = "div";

var F = function (t) {
  return t[t.None = 1] = "None", t[t.InitialFocus = 2] = "InitialFocus", t[t.TabLock = 4] = "TabLock", t[t.FocusLock = 8] = "FocusLock", t[t.RestoreFocus = 16] = "RestoreFocus", t[t.All = 30] = "All", t;
}(F || {});

var fe = Object.assign(A(function (l, e) {
  var r = i(null),
      u = g(r, e),
      f = l.initialFocus,
      t = l.containers,
      _l$features = l.features,
      o = _l$features === void 0 ? 30 : _l$features,
      a = _objectWithoutProperties(l, _excluded);

  S() || (o = 1);
  var s = U(r);
  V({
    ownerDocument: s
  }, Boolean(o & 16));
  var O = x({
    ownerDocument: s,
    container: r,
    initialFocus: f
  }, Boolean(o & 2));
  D({
    ownerDocument: s,
    container: r,
    containers: t,
    previousActiveElement: O
  }, Boolean(o & 8));
  var j = P(),
      E = I(function () {
    var _B;

    var T = r.current;
    !T || B(j.current, (_B = {}, _defineProperty(_B, d.Forwards, function () {
      return b(T, p.First);
    }), _defineProperty(_B, d.Backwards, function () {
      return b(T, p.Last);
    }), _B));
  }),
      v = {
    ref: u
  };
  return m.createElement(m.Fragment, null, Boolean(o & 4) && m.createElement(L, {
    as: "button",
    type: "button",
    onFocus: E,
    features: M.Focusable
  }), h({
    ourProps: v,
    theirProps: a,
    defaultTag: N,
    name: "FocusTrap"
  }), Boolean(o & 4) && m.createElement(L, {
    as: "button",
    type: "button",
    onFocus: E,
    features: M.Focusable
  }));
}), {
  features: F
});

function V(_ref, l) {
  var n = _ref.ownerDocument;
  var e = i(null);
  H(n == null ? void 0 : n.defaultView, "focusout", function (u) {
    !l || e.current || (e.current = u.target);
  }, !0), R(function () {
    l || (c(e.current), e.current = null);
  }, [l]);
  var r = i(!1);
  k(function () {
    return r.current = !1, function () {
      r.current = !0, C(function () {
        !r.current || (c(e.current), e.current = null);
      });
    };
  }, []);
}

function x(_ref2, r) {
  var n = _ref2.ownerDocument,
      l = _ref2.container,
      e = _ref2.initialFocus;
  var u = i(null);
  return R(function () {
    if (!r) return;
    var f = l.current;
    if (!f) return;
    var t = n == null ? void 0 : n.activeElement;

    if (e != null && e.current) {
      if ((e == null ? void 0 : e.current) === t) {
        u.current = t;
        return;
      }
    } else if (f.contains(t)) {
      u.current = t;
      return;
    }

    e != null && e.current ? c(e.current) : b(f, p.First) === y.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), u.current = n == null ? void 0 : n.activeElement;
  }, [r]), u;
}

function D(_ref3, u) {
  var n = _ref3.ownerDocument,
      l = _ref3.container,
      e = _ref3.containers,
      r = _ref3.previousActiveElement;

  var f = _();

  H(n == null ? void 0 : n.defaultView, "focus", function (t) {
    if (!u || !f.current) return;
    var o = new Set(e == null ? void 0 : e.current);
    o.add(l);
    var a = r.current;
    if (!a) return;
    var s = t.target;
    s && s instanceof HTMLElement ? G(o, s) ? (r.current = s, c(s)) : (t.preventDefault(), t.stopPropagation(), c(a)) : c(r.current);
  }, !0);
}

function G(n, l) {
  var e;

  var _iterator = _createForOfIteratorHelper(n),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var r = _step.value;
      if ((e = r.current) != null && e.contains(l)) return !0;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return !1;
}

export { fe as FocusTrap };